import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAutomobileIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.341}
      d="M31.17 17.032v-.001c-.048-8.383-6.867-15.202-15.274-15.202a.769.769 0 0 0-.775.775v.466C7.736 3.47 1.83 9.6 1.83 17.104c0 7.755 6.312 14.067 14.067 14.067 7.504 0 13.634-5.907 14.034-13.292h.466a.769.769 0 0 0 .775-.775v-.072Zm-3.384.847h.641c-.399 6.544-5.844 11.742-12.483 11.742-6.89 0-12.517-5.627-12.517-12.517v-.001C3.38 10.465 8.577 5.02 15.121 4.621v.526a.65.65 0 0 0-.003.272.77.77 0 0 0 .127.275c.114.167.31.364.587.64l.013.014c.318.341.778.801 1.357 1.356a712 712 0 0 0 4.084 4.06l5.944 5.896c.159.158.35.219.556.219ZM16.67 4.976V3.412c6.948.394 12.547 5.97 12.918 12.917h-1.54C23.835 12.162 17.81 6.161 16.671 4.976Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.341}
      d="M20.851 24.503a8.988 8.988 0 0 0 3.96-7.375l.172.001c0-.338.265-.604.604-.604.338 0 .604.266.604.604 0 3.432-1.716 6.622-4.568 8.53zm0 0-.005.004c-.33.24-.461.702-.21 1.078l.003.005a.8.8 0 0 0 .646.337c.14 0 .3-.027.437-.128l-.87-1.296Zm-2.888 1.256.325 1.327.039.166h.001a.794.794 0 0 0 .586-.93c-.097-.418-.536-.652-.951-.563Zm-2.067-1.838a6.813 6.813 0 0 0 6.816-6.816 6.813 6.813 0 0 0-6.816-6.817 6.813 6.813 0 0 0-6.817 6.817 6.813 6.813 0 0 0 6.817 6.816Zm0-12.083a5.275 5.275 0 0 1 5.267 5.267 5.275 5.275 0 0 1-5.267 5.267 5.275 5.275 0 0 1-5.267-5.267 5.275 5.275 0 0 1 5.267-5.267Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.341}
      d="M15.896 20.9a3.79 3.79 0 0 0 3.795-3.796 3.79 3.79 0 0 0-3.795-3.796 3.79 3.79 0 0 0-3.796 3.796 3.79 3.79 0 0 0 3.796 3.795Zm0-6.043a2.253 2.253 0 0 1 2.246 2.247 2.253 2.253 0 0 1-2.246 2.246 2.253 2.253 0 0 1-2.247-2.247 2.253 2.253 0 0 1 2.247-2.246Z"
    />
  </svg>
);
export default SvgAutomobileIcon;
